import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ClientModel } from 'src/app/models/gum-models/client.model';
import { ListOptions } from 'src/app/models/gum-models/list-options';
import { environment } from 'src/environments/environment';
import { GumOrganizationsService } from 'src/app/services/gumservices/gum-organizations.service';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  protected apiUrl = `${environment.apiUrl}/api/gum`;
  private baseUrl = `${this.apiUrl}/clients`;

  constructor(
    private http: HttpClient,
    private gumOrganizationsService: GumOrganizationsService
  ) {
    const orgJson = sessionStorage.getItem('currentOrganization');
    const org = orgJson ? JSON.parse(orgJson) : null;
  }

  getCurrentOrganizationId(): string | null {
    const currentOrg = this.gumOrganizationsService.getCurrentOrganization();
    return currentOrg?.id ?? null;
  }

  private getHeaders(listOptions?: ListOptions): HttpHeaders {
    const orgId = this.getCurrentOrganizationId();
    let headers = new HttpHeaders();

    if (orgId) {
      headers = headers.set('X-OrganizationId', orgId);
    }

    if (listOptions) {
      headers = listOptions.addListOptions(headers);
    }

    return headers;
  }

  getClients(includeDisabled = false): Observable<ClientModel[]> {
    const url = `${this.baseUrl}?includeDisabled=${includeDisabled}`;
    return this.http.get<ClientModel[]>(url, {
      headers: this.getHeaders(),
    });
  }

  getClient(clientId: string): Observable<ClientModel> {
    return this.http.get<ClientModel>(`${this.baseUrl}/${clientId}`, {
      headers: this.getHeaders(),
    });
  }

  createClient(client: ClientModel): Observable<ClientModel> {
    return this.http.post<ClientModel>(this.baseUrl, client, {
      headers: this.getHeaders().set('Content-Type', 'application/json'),
    });
  }

  updateClient(clientId: string, client: ClientModel): Observable<ClientModel> {
    return this.http.put<ClientModel>(`${this.baseUrl}/${clientId}`, client, {
      headers: this.getHeaders().set('Content-Type', 'application/json'),
    });
  }

  deleteClient(clientId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${clientId}`, {
      headers: this.getHeaders(),
    });
  }

  setClientEnabled(clientId: string, enabled: boolean): Observable<void> {
    return this.http.patch<void>(
      `${this.baseUrl}/${clientId}/enabled`,
      enabled,
      {
        headers: this.getHeaders().set('Content-Type', 'application/json'),
      }
    );
  }
}
